import { render } from "./LogoBinalogueWhiteAvatar.vue?vue&type=template&id=493d1c9e"
const script = {}

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__